import { Controller } from "@hotwired/stimulus"

// While any custom sketch-object is generating, poll the content page and swap in the fresh
// custom-objects panel — so "⏳ Generating…" flips to the finished object (or "✗ Failed")
// without a manual refresh. Pure client-side (no channel): it re-fetches THIS page, extracts
// the fresh #dst-sketch-objects-panel, and stops once nothing is generating. Mirrors
// voiceover_status_controller.
export default class extends Controller {
  // maxAttempts bounds a left-open tab so it can't poll forever; the server-side reaper flips a
  // long-stuck row to "failed" within this window, so the last polls observe it. ~13 min at 4s.
  static values = { status: String, interval: { type: Number, default: 4000 }, maxAttempts: { type: Number, default: 200 } }

  connect() {
    if (this.statusValue === "generating") this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.attempts = 0
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  stopPolling() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }

  async poll() {
    // Never blow away text the user is mid-typing in the generate/rename form — skip this tick
    // (the swap lands on the next tick once focus leaves the panel). Polling continues.
    if (this.element.contains(document.activeElement)) return
    if (++this.attempts > this.maxAttemptsValue) return this.stopPolling()

    let html
    try {
      const res = await fetch(window.location.href, { headers: { Accept: "text/html" }, credentials: "same-origin" })
      if (!res.ok) return
      html = await res.text()
    } catch (_e) {
      return // transient network error — keep polling
    }

    const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("#dst-sketch-objects-panel")
    if (!fresh) return

    const next = fresh.getAttribute("data-sketch-object-status-status-value")
    this.element.innerHTML = fresh.innerHTML
    // Reflect the settled status back onto the outer element so a Turbo-cached snapshot doesn't
    // restore with a stale "generating" attr and start a needless poll loop on back/forward.
    this.statusValue = next
    if (next !== "generating") this.stopPolling()
  }
}
